<template>
  <div>
    <Header v-if="!editing_tax">
      <template #actions>
        <BaseButton
          @click="addTax"
          variant="primary"
          icon="plus"
          bold
          size="md"
          color="green-5"
        >
          {{ $t("taxes.add_tax") }}
        </BaseButton>
      </template>
    </Header>

    <Header v-else :parent="'taxes'" @toParent="editing_tax = null">
      <template #title>
        {{ editing_tax.name || $t("taxes.add_tax") }}
      </template>
    </Header>

    <IQOSTable
      :rows="taxes"
      :cols="[
        {
          title: $t('taxes.col_name'),
          key: 'name',
        },
        {
          title: $t('taxes.col_percent'),
          key: 'percent',
          unit: '%',
          default: '0',
        },
        {
          title: $t('taxes.col_type'),
          renderer: (r) => $t('taxes.type_' + r.tax_type),
        },
      ]"
      :hasActions="true"
      v-if="!editing_tax"
    >
      <template #actions="slotProps">
        <BaseButton
          @click="editing_tax = slotProps.rowItem"
          variant="secondary"
          icon="pencil"
          size="sm"
          color="v1-grey-3"
        />
        <BaseButton
          @click="showRemoveUI(slotProps.rowItem._id)"
          variant="secondary"
          icon="trash"
          size="sm"
          color="v1-grey-3"
          class="ml-8"
        />
      </template>
    </IQOSTable>

    <PageContainer v-if="editing_tax">
      <div class="iqos-grid">
        <div class="iqos-column">
          <IQOS class="gap-row-xs" required>
            <div class="gap-row-1xs">
              <div class="qrw-label-sm v1-grey-7-color bold">
                {{ $t("taxes.col_name") }}
              </div>
              <BaseInput v-model="editing_tax.name" fullWidth />
            </div>
            <BaseDivider color="v1-grey-4" />
            <div class="gap-row-1xs">
              <div class="qrw-label-sm v1-grey-7-color bold">
                {{ $t("taxes.col_percent") }}
              </div>
              <BaseInput
                type="number"
                v-model.number="editing_tax.percent"
                fullWidth
                :disabled="editing_tax.tax_type == 'none'"
              />
            </div>
            <BaseDivider color="v1-grey-4" />
            <div class="gap-row-1xs">
              <div class="qrw-label-sm v1-grey-7-color bold">
                {{ $t("taxes.col_type") }}
              </div>
              <BaseTabSwitcher
                v-model="editing_tax.tax_type"
                fullWidth
                class="w-100"
                :tabs="[
                  {
                    text: $t('taxes.type_none'),
                    value: 'none',
                  },
                  {
                    text: $t('taxes.type_sales'),
                    value: 'sales',
                  },
                  {
                    text: $t('taxes.type_vat'),
                    value: 'vat',
                  },
                ]"
              />
            </div>
            <BaseDivider
              color="v1-grey-4"
              v-if="editing_tax.tax_type != 'none'"
            />
            <div class="gap-row-zero" v-if="editing_tax.tax_type != 'none'">
              <div class="qrw-paragraph-xs v1-grey-10-color">
                {{ $t("taxes.formula_hint") }}
              </div>
              <div class="qrw-paragraph-md bold v1-grey-10-color">
                {{ $t("taxes.formula_" + editing_tax.tax_type) }}
              </div>
            </div>
            <BaseDivider color="v1-grey-4" />
            <div class="tax-form-controls">
              <BaseButton
                @click="save"
                variant="primary"
                bold
                size="md"
                icon="check"
                color="green-5"
              >
                {{ $t("taxes.save_btn") }}
              </BaseButton>
            </div>
          </IQOS>
        </div>
      </div>
    </PageContainer>

    <DangerConfirmModal
      @confirm="confirmRemove"
      @cancel="remove_id = null"
      v-if="remove_id"
    >
      {{ $t("taxes.confirm_delete") }}
    </DangerConfirmModal>
  </div>
</template>

<script>
import TaxesAPI from "@/api/taxes";

export default {
  data() {
    return {
      taxes: [],

      editing_tax: null,

      remove_id: null,
    };
  },
  methods: {
    showRemoveUI(id) {
      this.remove_id = id;
      this.$nextTick(() => {
          this.editing_tax = null;
      });
    },
    confirmRemove() {
      TaxesAPI.removeTax(this.remove_id).finally((data) => {
        this.remove_id = null;
        this.fetchData();
      });
    },
    fetchData() {
      TaxesAPI.getTaxes(this.cafe._id).then((data) => {
        this.taxes = data.taxes;
      });
    },
    addTax() {
      TaxesAPI.addTax({
        cafe_id: this.cafe._id,
        name: "",
        tax_type: "none",
        percent: 0,
      }).then((data) => {
        this.taxes.push(data.tax);
        this.editing_tax = data.tax;
      });
    },
    save() {
      TaxesAPI.updateTax(this.editing_tax._id, this.editing_tax).then(
        (data) => {
          this.editing_tax = null;
          this.fetchData();
        }
      );
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.tax-form-controls {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
